import UtilsSchema from "@repoflow/schema/utils";

import {
  orgId,
  bucketId,
  fileId,
  hash,
  description,
  ext,
  extInput,
  size,
  status,
  visibility,
  visibilityInput,
  tags,
  derivedSize,
  derivedCount,
  createdAt,
  updatedAt
} from "./fields";

export default [
  ...UtilsSchema,
  {
    id: "/Public/BucketFile",
    type: "object",
    properties: {
      orgId,
      bucketId,
      fileId,
      hash,
      description,
      ext,
      size,
      status,
      visibility,
      tags,
      derivedSize,
      derivedCount,
      createdAt,
      updatedAt
    }
  },
  // The form the browser renders. `file` is the file widget's value — a wrapper
  // around a DOM File, which cannot cross the wire — so the app never sends this
  // shape to the API. It picks the hash and extension out of it and posts
  // /Public/BucketFile/CreateInput instead.
  {
    id: "/Public/BucketFile/Create",
    type: "object",
    properties: {
      tags,
      visibility: visibilityInput,
      file: {
        label: "File",
        widget: "file",
        type: "object",
        patternProperties: {
          "^.+$": {},
        },
      },
    },
    required: ["tags", "file"]
  },
  // What the create mutation actually receives; mirrors the non-null fields of
  // the GraphQL `BucketFileInputCreate`. Validate against this one server-side —
  // /Public/BucketFile/Create can never match an API payload.
  {
    id: "/Public/BucketFile/CreateInput",
    type: "object",
    properties: {
      hash,
      ext: extInput,
      tags,
      // Optional, and absent means private. Every caller that predates this
      // field — @repoflow/bucketws-api's files.create, which is what pagews
      // uploads through — sends {hash, ext} and keeps getting private files,
      // which is what it had and what it wants.
      visibility: visibilityInput,
    },
    required: ["hash", "ext", "tags"]
  },
  {
    id: "/Public/BucketFile/Update",
    type: "object",
    properties: {
      description,
      tags,
      // Also optional, and here absent means LEAVE IT ALONE rather than
      // "private". @repoflow/bucketws-api's files.update sends {description,
      // tags} and nothing else; if an absent value meant private, every
      // retag pagews performs would silently unpublish the file. model/bucket-file
      // drops the key before validating when the caller did not send one, so
      // an explicit null from a form is treated the same as not sending it.
      visibility: visibilityInput
    },
    required: [],
  },
];
